<template>
  <div class="ledger-edit-container">
    <!-- 头部导航与操作 -->
    <div class="edit-header">
      <div class="header-left-side">
        <el-button @click="goBack" class="back-btn">
          <el-icon class="mr-1"><ArrowLeft /></el-icon> 返回
        </el-button>
        <span class="edit-title">{{ isEdit ? '编辑' : '新增' }}</span>
      </div>
      <div class="header-actions">
        <el-button @click="goBack">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="onSubmit(formRef)">
          保存
        </el-button>
      </div>
    </div>

    <!-- 表单主内容区 -->
    <div class="edit-card-wrapper">
      <el-form
        label-width="120px"
        :model="formLabelAlign"
        ref="formRef"
        :rules="rules"
        class="premium-form"
      >
        <!-- 模块一：基本信息 -->
        <el-card class="form-card" shadow="never">
          <template #header>
            <div class="card-header">
              <span class="card-indicator"></span>
              <span class="card-title">基本信息</span>
            </div>
          </template>

          <el-row :gutter="24">
            <el-col :span="8" v-if="isEdit">
              <el-form-item label="id">
                <el-input v-model="formLabelAlign.device_id" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备名称" prop="device_name">
                <el-input v-model="formLabelAlign.device_name" placeholder="请输入设备名称" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备编号" prop="device_number">
                <el-input v-model="formLabelAlign.device_number" placeholder="请输入设备编号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="序列号" prop="device_sn">
                <el-input v-model="formLabelAlign.device_sn" placeholder="请输入序列号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备类型" prop="device_type">
                <el-select 
                  v-model="formLabelAlign.device_type" 
                  placeholder="请选择设备类型" 
                  style="width: 100%;"
                  @change="handleDeviceTypeChange"
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态" prop="status">
                <el-select v-model="formLabelAlign.status" placeholder="请选择状态" style="width: 100%;">
                  <el-option label="正常" :value="1" />
                  <el-option label="禁用" :value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备大图">
                <div class="image-preview-container">
                  <el-image 
                    v-if="formLabelAlign.device_img_url"
                    :src="formLabelAlign.device_img_url" 
                    :preview-src-list="[formLabelAlign.device_img_url]"
                    fit="cover" 
                    style="width: 60px; height: 60px; border-radius: 6px; border: 1px solid #e4e7ed; cursor: pointer;"
                  />
                  <div v-else class="image-empty-box">
                    <span class="text-10 text-gray-400">暂无图片</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备png图">
                <div class="image-preview-container">
                  <el-image 
                    v-if="formLabelAlign.device_png_url"
                    :src="formLabelAlign.device_png_url" 
                    :preview-src-list="[formLabelAlign.device_png_url]"
                    fit="contain" 
                    style="width: 60px; height: 60px; border-radius: 6px; border: 1px solid #e4e7ed; cursor: pointer; background-color: #f5f7fa;"
                  />
                  <div v-else class="image-empty-box">
                    <span class="text-10 text-gray-400">暂无图片</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            
          </el-row>
        </el-card>

        <!-- 模块二：制造与技术参数 -->
        <el-card class="form-card" shadow="never">
          <template #header>
            <div class="card-header">
              <span class="card-indicator"></span>
              <span class="card-title">制造与技术参数</span>
            </div>
          </template>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="生产厂商" prop="manufacturer">
                <el-input v-model="formLabelAlign.manufacturer" placeholder="请输入生产厂商" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="系统固件版本" prop="firmware_version">
                <el-input v-model="formLabelAlign.firmware_version" placeholder="请输入系统固件版本" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="硬件型号" prop="hardware_model">
                <el-input v-model="formLabelAlign.hardware_model" placeholder="请输入硬件型号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出厂日期" prop="manufacture_date">
                <el-date-picker
                  style="width: 100%;"
                  value-format="YYYY-MM-DD"
                  v-model="formLabelAlign.manufacture_date"
                  type="date"
                  placeholder="选择出厂日期"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 模块三：所属权与备注 -->
        <el-card class="form-card" shadow="never">
          <template #header>
            <div class="card-header">
              <span class="card-indicator"></span>
              <span class="card-title">所属权与备注</span>
            </div>
          </template>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="租户企业名称" prop="tenant_name">
                <el-select v-model="formLabelAlign.tenant_name" placeholder="请选择租户企业名称" style="width: 100%;" filterable clearable>
                  <el-option v-for="item in tenantOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="所属项目" prop="project_name">
                <el-select v-model="formLabelAlign.project_name" placeholder="请选择所属项目" style="width: 100%;" filterable clearable @change="handleProjectChange">
                  <el-option v-for="item in projectOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="施工面积(㎡)" prop="project_area">
                <el-input v-model="formLabelAlign.project_area" placeholder="自动带出项目施工面积" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工序类型" prop="work_process">
                <el-select v-model="formLabelAlign.work_process" placeholder="请选择工序类型" style="width: 100%;" filterable clearable>
                  <el-option v-for="item in procedureOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :rows="3" v-model="formLabelAlign.remark" placeholder="请输入备注" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { ArrowLeft } from "@element-plus/icons-vue";
import { EquipmentLedgerAdd, EquipmentLedgerDetail } from "@/api/equipmentLedger.js";
import { EquipmentClassificationSelectList } from "@/api/equipmentClassification.js";
import { TenantDropdownList } from "@/api/tenant.js";
import { ProcedureDropdownList } from "@/api/procedure.js";
import { ProjectListSelect } from "@/api/project.js";

const route = useRoute();
const router = useRouter();

const formRef = ref(null);
const isEdit = ref(false);
const submitting = ref(false);
const typeOptions = ref([]);
const tenantOptions = ref([]);
const procedureOptions = ref([]);
const projectOptions = ref([]);

const formLabelAlign = reactive({
  id: 0,
  device_id: "",
  device_sn: "",
  device_type: "",
  device_img_url: "",
  device_png_url: "",
  device_name: "",
  device_number: "",
  manufacturer: "",
  firmware_version: "",
  work_process: "",
  hardware_model: "",
  manufacture_date: "",
  status: 1,
  tenant_name: "",
  project_name: "",
  project_area: 0,
  remark: ""
});

const rules = reactive({
  device_sn: [
    { required: true, message: "序列号不能为空", trigger: "blur" }
  ],
  device_name: [
    { required: true, message: "设备名称不能为空", trigger: "blur" }
  ],
  device_number: [
    { required: true, message: "设备编号不能为空", trigger: "blur" }
  ],
  device_type: [
    { required: true, message: "设备类型不能为空", trigger: "change" }
  ]
});

// 选择所属项目后，自动获取/带出对应的施工面积 (只读)
const handleProjectChange = (val) => {
  const selected = projectOptions.value.find(
    (item) => item.label === val || item.value === val
  );
  if (selected) {
    formLabelAlign.project_area = selected.extra != null ? Number(selected.extra) : 0;
  } else {
    formLabelAlign.project_area = 0;
  }
};

// 选择设备类型后，自动获取/带出对应的设备大图 and 设备png图
const handleDeviceTypeChange = (val) => {
  const selected = typeOptions.value.find(
    (item) => item.label === val || item.value === val
  );
  if (selected) {
    formLabelAlign.device_img_url = selected.img || selected.device_img_url || selected.image || "";
    formLabelAlign.device_png_url = selected.pngImg || selected.device_png_url || "";
  }
};

onMounted(() => {
  getClassificationList();
  getTenantList();
  getProcedureList();
  getProjectList();
  const id = route.query.id;
  if (id) {
    isEdit.value = true;
    loadDetail(id);
  }
});

// 获取分类下拉列表
const getClassificationList = async () => {
  try {
    const res = await EquipmentClassificationSelectList();
    if (res.code === 200) {
      typeOptions.value = res.data || [];
    }
  } catch (e) {
    console.error("加载分类列表失败", e);
  }
};

// 获取租户下拉列表
const getTenantList = async () => {
  try {
    const res = await TenantDropdownList();
    if (res.code === 200) {
      tenantOptions.value = res.data || [];
    }
  } catch (e) {
    console.error("加载租户列表失败", e);
  }
};

// 获取项目下拉列表
const getProjectList = async () => {
  try {
    const res = await ProjectListSelect();
    if (res.code === 200) {
      projectOptions.value = res.data || [];
    }
  } catch (e) {
    console.error("加载项目列表失败", e);
  }
};

// 获取工序下拉列表
const getProcedureList = async () => {
  try {
    const res = await ProcedureDropdownList();
    if (res.code === 200) {
      procedureOptions.value = res.data || [];
    }
  } catch (e) {
    console.error("加载工序列表失败", e);
  }
};

// 加载台账详情
const loadDetail = async (id) => {
  try {
    const res = await EquipmentLedgerDetail({ id: Number(id) });
    if (res.code === 200) {
      if (res.data) {
        Object.assign(formLabelAlign, res.data);
      } else {
        ElMessage.error("未找到设备详情数据");
      }
    } else {
      ElMessage.error(res.msg || "加载详情数据失败");
    }
  } catch (e) {
    ElMessage.error("加载详情数据失败");
  }
};

const goBack = () => {
  router.push("/equipment/equipmentLedger");
};

// 提交表单
const onSubmit = async (formEl) => {
  if (!formEl) return;
  await formEl.validate(async (valid) => {
    if (valid) {
      submitting.value = true;
      try {
        const data = { ...formLabelAlign };
        const res = await EquipmentLedgerAdd(data);
        if (res.code === 200) {
          ElMessage.success("保存成功");
          goBack();
        } else {
          ElMessage.error(res.msg || "保存失败");
        }
      } catch (error) {
        ElMessage.error("保存失败，请重试");
      } finally {
        submitting.value = false;
      }
    } else {
      ElMessage.warning("请检查表单中填写的必填项");
    }
  });
};
</script>

<style lang="less" scoped>
.ledger-edit-container {
  padding: 24px;
  background-color: #ffffff;
  min-height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f2f5;
}

.header-left-side {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.back-btn {
  border: 1px solid #dcdfe6;
  background-color: #fff;
  color: #606266;
  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

.edit-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2f3d;
}

.edit-card-wrapper {
  width: 95%;
  max-width: none;
  margin: 0 auto;
}

.form-card {
  margin-bottom: 28px;
  border: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  overflow: hidden !important;

  :deep(.el-card__header) {
    background-color: transparent !important;
    border-bottom: none !important;
    padding: 12px 0 !important;
    overflow: hidden !important;
  }

  :deep(.el-card__body) {
    padding: 16px 0 !important;
    overflow: hidden !important;
  }
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-indicator {
  display: inline-block;
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 30px;
  padding-bottom: 50px;
}

.mr-1 {
  margin-right: 4px;
}

.image-empty-box {
  width: 60px;
  height: 60px;
  background-color: #f5f7fa;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #30313383;
}
</style>
